"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.position = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore
// translate-ignore

const pageId = exports.pageId = 32924700882;
const slug = exports.slug = 'guides/apps/marketplace/measuring-app-performance';
// translate-ignore
const navTitle = exports.navTitle = 'Measuring app performance';
const title = exports.title = 'Measuring app performance';
const name = exports.name = 'Measure app performance';
const metaDescription = exports.metaDescription = "Learn more about measuring your app's performance through the app listing page details view.";
// translate-ignore
const position = exports.position = 8;
const toc = exports.toc = [{
  "depth": 0,
  "id": "review-your-app-s-marketplace-analytics",
  "label": "Review your app's marketplace analytics",
  "parent": null
}, {
  "depth": 1,
  "id": "installs",
  "label": "Installs",
  "parent": "review-your-app-s-marketplace-analytics"
}, {
  "depth": 1,
  "id": "listing-analytics",
  "label": "Listing analytics",
  "parent": "review-your-app-s-marketplace-analytics"
}, {
  "depth": 1,
  "id": "user-actions",
  "label": "User actions",
  "parent": "review-your-app-s-marketplace-analytics"
}, {
  "depth": 0,
  "id": "customer-feedback",
  "label": "Customer Feedback",
  "parent": null
}, {
  "depth": 0,
  "id": "key-resources",
  "label": "Key Resources",
  "parent": null
}, {
  "depth": 0,
  "id": "app-activity-%26-usage",
  "label": "App Activity & Usage",
  "parent": null
}, {
  "depth": 0,
  "id": "measure-engagement-with-utm-parameters",
  "label": "Measure engagement with UTM parameters",
  "parent": null
}, {
  "depth": 2,
  "id": "related-docs",
  "label": "Related docs",
  "parent": "measure-engagement-with-utm-parameters"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      ul: "ul",
      li: "li",
      strong: "strong",
      h3: "h3",
      em: "em",
      img: "img",
      code: "code",
      h4: "h4"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Measure app performance"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["After ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/listing-your-app",
        children: "listing your app"
      }), " in the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://ecosystem.hubspot.com/marketplace/apps",
        children: "HubSpot App Marketplace"
      }), ", you can review performance metrics for your app in your developer account. This includes performance metrics such as usage data, install data, and listing analytics."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Review your app's marketplace analytics"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In your ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/apps/overview",
          children: "app developer account"
        }), ", navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Marketplace"
        }), " > ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "App Listings"
        }), ". This will bring you to a dashboard with all your App Marketplace listings."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "name"
        }), " of your app."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Installs"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Installs"
      }), " tab, review detailed metrics on your app's performance. At the top, you can set the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Frequency"
      }), " and ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Date range"
      }), " for your data."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can analyze the following data:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Active installs"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "App installs"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "App uninstalls"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "App installs vs uninstalls"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Free vs Paid installs"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Free vs Paid uninstalls"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Install by Country"
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Installs by Hub"
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/marketplace-providers/marketplace-providers-marketplace-analytics-reports.png",
        alt: "Screenshot of the Installs tab"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Listing analytics"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Listing analytics"
      }), " tab, review metrics for the app's listing page. At the top, you can set the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Frequency"
      }), " and ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Date range"
      }), " for your data."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can analyze the following data:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Pageviews"
        }), ": number of pageviews over the specified date range, plotted by frequency."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Pageview Source"
        }), ": percentage of pageviews over the specified date range attributed to a specific source, such as public or in-app."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "CTA Usage"
        }), ": number of clicks of your listing page CTAs, plotted by frequency."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Free vs Paid Pageviews"
        }), ": percentage of pageviews over the specified date range attributed to paid vs free users."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Pageviews by Country"
        }), ": number of pageviews over the specified date range associated with individual countries."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Pageviews by Hub"
        }), ": number of pageviews over the specific date range from users in specific hubs."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/marketplace-listing-analytics.png",
        alt: "Screenshot of the reports on the Listing analytics tab"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Pageviews by Domain"
        }), ": number of pageviews over the specific date range from users associated with a particular domain. You can see the following info for these pageviews:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Domain name"
            }), ": name of the domain associated with these pageviews."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Installed"
            }), ": whether an account associated with that domain has installed the app."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "First seen"
            }), ": date of the first pageview associated with this domain."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Last seen"
            }), ": date of the most recent pageview associated with this domain."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Pageview count"
            }), ": total number of pageviews associated with this domain."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To export the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Pageviews by domain"
      }), " data, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Actions"
      }), " dropdown menu in the top right of the report, then select ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Download CSV"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/view-pageviews-by-domain.png",
        alt: "Screenshot of the Pageviews by Domain report"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "User actions"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "User actions"
      }), " tab, review the type and count of user actions that occurred from the app:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["At the top, you can filter your user actions by ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "date range"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the table, review the following:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "User action:"
            }), " the type of activity that the user engaged in. For example, the number of contacts created from the app, the count of files uploaded, and more."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Activity:"
            }), " the count of user actions."]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To sort the table by ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "user action"
        }), " or ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "activity"
        }), " count, click the table's ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "headers"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/image-png-Dec-13-2024-12-35-05-9054-PM.png",
        alt: "Screenshot of the User actions tab"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Customer Feedback"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To view all reviews that customers have submitted for your app, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: "Customer Feedback"
      }), " tab."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/DD%20-%20Reviews.png",
        alt: "Screenshot of the Customer Feedback tab"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Ratings & Reviews"
      }), " section, you can filter the reviews by the number of stars given, the customer's industry, and the customer's company size."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To reply to a review:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Below the review, click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Reply"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the dialog box, enter your ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "reply"
        }), " to the customer, then click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Send"
        }), ". This reply will be publicly visible on your app listing."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To edit notifications for reviews received:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["In the top right, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Actions"
            }), " dropdown menu and click ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Edit notifications"
            }), "."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["On the ", (0, _jsxRuntime.jsx)(_components.em, {
              children: "Notifications"
            }), " page, search for ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Marketplace"
            }), " and select ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Listing New Reviews"
            }), " to get notified when a customer leaves a review."]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To send your review link to a customer:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["In the top right, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Actions"
            }), " dropdown menu and click ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Copy review link"
            }), "."]
          }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
            children: "Email or send this link to your customer for them to leave a review."
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To review all survey responses:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["In the left sidebar menu, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Uninstall Survey Responses"
            }), " tab,"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["To export the responses, in the top left, click ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Export."
            }), " In the dialog box, click the File format dropdown menu and select ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "XLSX"
            }), ", ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "XLS"
            }), ", or ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "CSV."
            }), ". Then, click ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Export"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To review any private feedback responses to your team, in the left sidebar menu, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Private Feedback"
        }), " tab."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Key Resources"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Key Resources"
      }), " section, review the following resources:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "App partner program benefits:"
        }), " the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "App Partner Program Benefits"
        }), " guide will lists all benefits that you get as a partner with a listed app on the Hubspot App Marketplace."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Feedback survey:"
        }), " a feedback survey to provide feedback about the app partner experience."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "App partner manager:"
        }), " the contact information for your app partner manager."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "App Activity & Usage"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "App Activity & Usage"
      }), " section, you can review usage data for your app:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Installation"
        }), " report, you can view how many active installs your app has, measured by how many accounts have generated a successful API call in the past rolling 30 day period."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Top portals"
        }), " report, click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "View top portals"
        }), " to see the accounts that have the highest usage of your app."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["On the right, under ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Feature usage"
        }), ", you can measure the usage of different actions and API requests over time:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["To include an additional action, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "dropdown menu"
            }), " at the top of the report, then select an ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "action"
            }), "."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["To remove an action, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "x"
            }), " to the right of the action at the top of the report."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["To change the time period, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "dropdown menu"
            }), " at the top right of the report, then select a ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "time period"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/marketplace-providers/updated-app-activity-and-usage-reporting.png",
        alt: "Screenshot of the App Activity & Usage tab"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Under the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Feature usage"
        }), " report, you can also review recent errors that've occurred:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["To change the time period, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "dropdown menu"
            }), " at the top right, then select a ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "time period"
            }), "."]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["Errors are categorized into the following types:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
              children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Client errors"
                }), ": issues usually caused by a malformed request from your app."]
              }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Server errors:"
                }), " issues from processing a request on the backend or a problem on HubSpot's backend."]
              }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Unauthorized errors:"
                }), " authentication or missing scope issues."]
              }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Rate limit errors:"
                }), " caused by making too many requests in a given time period."]
              }), "\n"]
            }), "\n"]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/marketplace-providers/app-partner-error-rates-report.png",
        alt: "Screenshot of Error rates report"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Measure engagement with UTM parameters"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In addition to the above metrics, you can further measure engagement by including UTM parameters in the URLs on your app listing page. This lets you view how much traffic is coming to your website from your listing page."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "It's recommended to add UTM parameters to the following URLs included on your listing page:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Supporting content on your App Marketplace listing page, such as your company website, supporting documentation, case study, and privacy policy."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The OAuth install URL that customers use when installing the app."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, you could add the following string of UTM parameters to the end of your documentation URL:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "?utm_campaign=appmarketplacelisting&utm_medium=referral&utm_source=hubspot"
      })
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["It's recommended to use UTM parameters that are consistent with other UTM tracking you or your marketing team may be using. Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/settings/how-do-i-create-a-tracking-url",
          children: "creating tracking URLs"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To add UTM parameters to the OAuth install URL:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In your app developer account, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Apps"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "name"
        }), " of the app to edit its details."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the left sidebar, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Basic info"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["At the top, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Auth"
        }), " tab."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Redirect URLs"
        }), " section, update your redirect URL to contain your UTM parameters. This will update the app's install URL after saving, so you'll need to be sure you've updated any user-facing links to use the new URL."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the bottom left, click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Save"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["The install button URL field has a limit of 250 characters. If your UTM parameters result in exceeding that limit, you may need to use a url shortener, such as ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://bitly.com/",
          children: "Bitly"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/DD%20-%20redirect%20URL.png",
        alt: "Screenshot of the Redirect URL field"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To add UTM parameters to the app's supporting content:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In your app developer account, navigate to ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "App Marketplace"
          }), " > ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "Listings"
          }), "."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Marketplace Listings"
          }), " table, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "name"
          }), " of the app."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In the top right, click ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "Edit listing"
          }), "."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["On the ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Listing info"
          }), " tab, update the URL in the ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Install button URL"
          }), " field with your UTM parameters."]
        }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
          children: (0, _jsxRuntime.jsx)(_components.img, {
            src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/DD%20-%20Test%20app%20listing.png",
            alt: "Screenshot of the Install button URL field"
          })
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["At the top, click the ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "Support info"
          }), " tab."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In the ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Contact info"
          }), ", ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Support resources"
          }), ", and ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Terms of Service and Privacy Policy"
          }), ", sections, update the URLs with your UTM parameters."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Once you've updated your URLs, click ", (0, _jsxRuntime.jsx)(_components.strong, {
            children: "Submit for review"
          }), " in the top right corner."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Once reviewed and approved, the URLs on your app's listing page will be updated with your UTM parameters. You can then use analytics tools, such as ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "https://knowledge.hubspot.com/reports/analyze-your-site-traffic-with-the-traffic-analytics-tool",
            children: "HubSpot"
          }), " or Google Analytics, to view traffic coming from your URLs as categorized by your UTM parameters. ", (0, _jsxRuntime.jsx)(_components.img, {
            src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/DD%20-%20Support%20docs.png",
            alt: "DD - Support docs"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h4, {
      children: "Related docs"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/certification-requirements",
        children: "App certification requirements"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/marketplace/app-marketplace-listing-requirements",
        children: "App listing requirements"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}